<template>
<el-select v-model="selectVal" :placeholder="placeholder" multiple filterable clearable :multiple-limit="5" @change="toggleSelector">
    <el-option v-for="(item,index) in list" :key="index" :label="item.realname" :value="item.id"></el-option>
</el-select>
</template>

<script>
import {
    post
} from '@/api/http.js'
export default {
    props: {
        value: {
			type: Array,
			default: function() {
                return [];
            }
		},
        withLeave: {
            type: Boolean,
            default: function () {
                return false;
            }
        },
        placeholder: {
            type: String,
            default: function () {
                return "请选择"
            }
        },
    },
    data() {
        return {
            selectVal: [],
            list: []
        }
    },
    created() {
        this.getUserList();
    },
    watch: {
        value: {
			handler(newVal) {
				this.val = newVal;
			},
			immediate: true
		},
    },
    methods: {
        getUserList() {
            let url = "/api/ucenter.user/getStaffList";
            let options = {};
            options.with_leave = this.withLeave ? 1 : 0;

            post(url, options).then(res => {
                this.list = res.data.list;
            })
        },
        toggleSelector() {
            this.$emit('input', this.selectVal);
        }
    }
}
</script>

<style>

</style>
